import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import type { Balance, BillingTransaction, PendingTopup, Tariff } from '../entities/account.models';
import type { AccountData } from './account.data';
import { BillingApiService } from './billing-api.service';

@Injectable()
export class HttpAccountData implements AccountData {
  private readonly billingApi = inject(BillingApiService);

  getBalance(): Observable<Balance> {
    return this.billingApi.getBalance();
  }

  getTariff(): Observable<Tariff> {
    return this.billingApi.getTariff();
  }

  getTransactions(): Observable<BillingTransaction[]> {
    return this.billingApi.getTransactions();
  }

  getPendingTopup(): Observable<PendingTopup | null> {
    return this.billingApi.getPendingTopup();
  }

  dismissPendingTopup(transactionId: string): Observable<void> {
    return this.billingApi.dismissPendingTopup(transactionId);
  }
}
